import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { GroupEmailTableRow, IGroupEmailTableRowCallbacks } from '../GroupEmailTableRow';
import { styleSheet } from './styles';

interface IGroupEmailTableRowsProps {
	campaigns: Api.ICampaign[];
	impersonationContext?: Api.IImpersonationContext;
	onRequestCallbacksForCampaign?(campaign: Api.ICampaign): IGroupEmailTableRowCallbacks;
}

export const GroupEmailTableRows: React.FC<IGroupEmailTableRowsProps> = observer(
	({ campaigns, impersonationContext, onRequestCallbacksForCampaign }) => {
		return (
			<>
				{campaigns.map(campaign => {
					return (
						<GroupEmailTableRow
							className={css(styleSheet.groupItem)}
							impersonationContext={impersonationContext}
							isGroupItem={true}
							key={campaign.id}
							campaign={campaign}
							{...(onRequestCallbacksForCampaign?.(campaign) || {})}
						/>
					);
				})}
			</>
		);
	}
);
